import allowlist from './allowlist/allowlist';
import availableIndexes from './availableIndexes/availableIndexes';
import siteInit from './siteInit/siteInit';
import extendedBreadcrumbs from './extendedBreadcrumbs/extendedBreadcrumbs';
import searchnav from './searchnav/searchnav';
import fallbackLayout from './fallbackLayout.ts';
import prevRoute from './prevRoute/prevRoute';

const reducers = {
  allowlist,
  availableIndexes,
  siteInit,
  extendedBreadcrumbs,
  searchnav,
  fallbackLayout,
  prevRoute,
};

export default reducers;
